import { Wind, Eye, Brain, PenLine, Trophy } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { CORE_SKILLS } from "@/data/content";

const ICONS = { calm: Wind, visualize: Eye, remember: Brain, practice: PenLine, perform: Trophy };

const CoreSkills = () => (
  <section id="core-skills" data-testid="core-skills-section" className="py-20 lg:py-28 bg-white scroll-mt-24">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <SectionHeading
        align="center"
        eyebrow="The Five Core Skills"
        title="Five skills. One learning system."
      />

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5" data-testid="core-skills-grid">
        {CORE_SKILLS.map((skill, i) => {
          const Icon = ICONS[skill.icon];
          return (
            <Reveal key={skill.title} delay={i * 0.08}>
              <div
                data-testid={`core-skill-${skill.title.toLowerCase()}`}
                className="group h-full rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] hover:border-brand/40"
              >
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-light text-brand transition-colors duration-300 group-hover:bg-brand group-hover:text-white">
                  <Icon size={26} strokeWidth={1.8} />
                </div>
                <h3 className="mt-5 text-lg font-bold uppercase tracking-wide text-slate-900">{skill.title}</h3>
                <p className="mt-1 text-xs font-bold uppercase tracking-wider text-brand">{skill.sub}</p>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">{skill.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default CoreSkills;
